import * as React from 'react';

// Source: https://www.figma.com/design/rTtmSN6AVSsEL0oVahRdUB/M3-Eng-Handoff?node-id=295-17370&m=dev
const LockIcon = ({ ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...rest}>
    <g clipPath="url(#clip0_295_17370)">
      <path
        d="M11.067 4.86602H10.467V3.66602C10.467 2.01002 9.12299 0.666016 7.46699 0.666016C5.81099 0.666016 4.46699 2.01002 4.46699 3.66602V4.86602H3.86699C3.20699 4.86602 2.66699 5.40602 2.66699 6.06602V12.066C2.66699 12.726 3.20699 13.266 3.86699 13.266H11.067C11.727 13.266 12.267 12.726 12.267 12.066V6.06602C12.267 5.40602 11.727 4.86602 11.067 4.86602ZM9.32699 4.86602H5.60699V3.66602C5.60699 2.64002 6.44099 1.80602 7.46699 1.80602C8.49299 1.80602 9.32699 2.64002 9.32699 3.66602V4.86602Z"
        fill="#5B6780"
      />
    </g>
    <defs>
      <clipPath id="clip0_295_17370">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default LockIcon;
